import { Container} from './styled';

export function Contact(props) {
  return (
    <Container>
      <div className='avatar--skeleton'>
        <span/>
      </div>
      <div className='info--skeleton'>
        <div className='name--skeleton'>
          <span/>
        </div>
        <div className='description--skeleton'>
          <span/>
        </div>
      </div>
    </Container>
  );
}